import { React, useRef } from "react";
import { BrowserRouter as Router, useLocation ,Routes, Route } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import './App.css';
import Home from '../src/pages/Home/Home.jsx';
import Team from '../src/pages/Team/Team';
import Research from '../src/pages/Research/Research';
import Publications from '../src/pages/Publications/Publications';
import FullProfile from '../src/pages/Profile/Profile';
import Resource from '../src/pages/Resources/Resource';
import JoinUs from '../src/pages/Join Us/JoinUs';
import News from '../src/pages/News/News';
import './index.css';

function App() {

  return (
    <Router>
      <PageTransition />
    </Router>
  );
}

function PageTransition() {
  const location = useLocation(); // useLocation hook is now inside the Router
    const nodeRef = useRef(null); // Create ref


  return (
    <TransitionGroup component={null}>
      <CSSTransition
        key={location.pathname} // Ensure each transition is unique using location.key
        timeout={500} // Set the transition duration (500ms)
        classNames="page-fade"
        nodeRef={nodeRef} // The CSS class name for the transition
      >
       
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/join-us" element={<JoinUs />} />
            <Route path="/team" element={<Team />} />
            <Route path="/research" element={<Research />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/anuvab" element={<FullProfile />} />
            <Route path="/resources" element={<Resource />} />
            <Route path="/news" element={<News />} />
          </Routes> 

      </CSSTransition>
    </TransitionGroup>
  );
}

export default App;
